/**
 * Cascading dropdown module for Offer Group → Offer Type selection.
 * Used in Offer Create and Edit forms.
 */

import type { OfferTypeItem } from '../lib/types';

export interface CascadingDropdownOptions {
    groupSelect: HTMLSelectElement;
    typeSelect: HTMLSelectElement;
    groupHidden?: HTMLInputElement;
    offerTypes: OfferTypeItem[];
    currentGroup?: string;
    currentTypeId?: string;
    onGroupChange?: (group: string) => void;
}

/**
 * Setup cascading Group → Type dropdown with visibility toggling
 */
export function setupCascadingDropdown(options: CascadingDropdownOptions) {
    const { groupSelect, typeSelect, groupHidden, offerTypes, currentGroup, currentTypeId, onGroupChange } = options;

    // Initialize with current values
    if (currentGroup) {
        groupSelect.value = currentGroup;
        populateTypeDropdown(currentGroup, currentTypeId);
    }

    // Handle group change
    groupSelect.addEventListener('change', function () {
        const selectedGroup = this.value;
        
        // Update hidden field
        if (groupHidden) {
            groupHidden.value = selectedGroup;
        }

        // Repopulate type dropdown
        populateTypeDropdown(selectedGroup);

        // Custom callback
        if (onGroupChange) {
            onGroupChange(selectedGroup);
        }
    });

    function populateTypeDropdown(selectedGroup: string, selectedTypeId?: string) {
        typeSelect.innerHTML = '<option value="">-- Select Type --</option>';

        if (!selectedGroup) {
            typeSelect.disabled = true;
            return;
        }

        const filtered = offerTypes.filter(t => t.Group === selectedGroup);
        filtered.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.Id.toString();
            option.textContent = item.Name || item.Key;
            if (selectedTypeId && item.Id.toString() === selectedTypeId) {
                option.selected = true;
            }
            typeSelect.appendChild(option);
        });

        typeSelect.disabled = false;
    }
}
